import { render, staticRenderFns } from "./MaintenanceCard.vue?vue&type=template&id=80283e02&"
import script from "./MaintenanceCard.vue?vue&type=script&lang=js&"
export * from "./MaintenanceCard.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
